import { FC } from "react";
import styled from "styled-components";
import { Image } from "./Image";

interface Props {
  path: string;
  width?: string;
  margin?: string;
  square?: boolean;
  style?: object;
  className?: string;
  alt?: string;
}

export const Avatar: FC<React.PropsWithChildren<Props>> = ({
  path,
  width = "4rem",
  margin,
  square,
  style,
  className,
  alt = "",
}) => (
  <AvatarContainer
    width={width}
    margin={margin}
    square={square}
    style={style}
    className={className}
  >
    <Image path={path} alt={alt} />
  </AvatarContainer>
);

const AvatarContainer = styled.div<{ width?: string; margin?: string; square?: boolean }>`
  display: inline-block;
  border-radius: ${(p) => (p.square ? "0" : "50%")};
  background: #c7b4fd;
  width: ${(p) => p.width || "4rem"};
  height: ${(p) => p.width || "4rem"};
  overflow: hidden;
  margin: ${(p) => p.margin || "2rem 0.75rem"};

  @media only screen and (max-width: 30rem) {
    margin: 1rem 0.75rem;
  }
`;
